import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
	Restart({ commit }, list) {
		return new Promise((resolve, reject) => {
			axios({
				url: "/gateway",
				data: { command: "restart" },
				method: "POST",
			})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};

// mutations
const mutations = {};

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations,
};
